import AppState, { POPUPS, SCREENS } from '@/js/AppState';
import Button from '@cmp/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Texts from 'react-sdk/Texts';

import HomeScreens from '@scr/_layouts/HomeScreens/HomeScreens';
import Config from 'react-sdk/Config';
import PopupsManager from 'react-sdk/PopupsManager';
import SoundPlayer from 'react-sdk/SoundPlayer';
import SaveGame from '@/js/SaveGame';

import classes from './PopupIntro.module.css';
import clsx from 'clsx'
import Dial from '@/components/Dial/Dial';
import { getUrlVar } from 'react-sdk/utils';
import WaveSection from '@/components/shared/WaveSection/WaveSection';

const PopupIntro = () => {
  
  useEffect(() => {

    if(AppState.skipIntro) AppState.setScreen(SCREENS.GAME)
    else {
      AppState.dials.playSequence("Dials", "intro", () => {
        PopupsManager.close(POPUPS.INTRO)
      }, true)
    }
  }, []);


  return (
    <div className={classes.PopupIntro}>

      <WaveSection contentClasses={classes.content}>
      </WaveSection>
      <img className={ classes.main_img} src={Texts.get('intro-image')} />


      {/* <Dial /> */}
    </div>
  );
};

export default  observer(PopupIntro)
